import { createSelector } from '@reduxjs/toolkit';
import { selectJsonQuery } from './selectJsonQuery';
import { dealTypeFromJsonQuery } from '../../../packages/JsonQuery';

export const selectDealTypeFilter = createSelector(selectJsonQuery, jsonQuery => dealTypeFromJsonQuery(jsonQuery));
